import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import _ from 'lodash';

import { SUBTABS, RATE_STEPS } from './ConstPaths';
import TestDriveRateClient from './TestDriveRateClient';
import TestDriveRatePractitioner from './TestDriveRatePractitioner';
import TestDriveRateIssues from './TestDriveRateIssues';
import TestDriveRateReview from './TestDriveRateReview';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  isLowTechPath: PropTypes.bool,
  activeTestDrive: PropTypes.object,
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  isLowTechPath: false,
  activeTestDrive: {}
};

//Manage the wizard form for the Test-drive / Rate sub-tab
//Initialize the forms with props and manage those as local state.
// Following pattern described in https://goshacmd.com/wizard-form-collect-info/

//the steps of the wizard form:
const steps = RATE_STEPS;

const BASE_URL = SUBTABS.RATE + "/";
const NEXT_SECTION = SUBTABS.INTERPRET;

class TestDriveRate extends React.Component {
  constructor(props) {
    super(props);

    //manage the incoming props  - those that can be changed in this section - as local state
    this.state = {
      prevActiveTestDrive: this.props.activeTestDrive, //for getDerivedStateFromProps
      activeTestDrive: this.props.activeTestDrive,

      // activeTestDriveClientRating: this.props.activeTestDriveClientRating,
      // activeTestDriveClientFeedback: this.props.activeTestDriveClientFeedback,
      // activeTestDrivePractitionerRating: this.props.activeTestDrivePractitionerRating,
      // activeTestDriveIssuesNoted: this.props.activeTestDriveIssuesNoted,
      // activeTestDrivePractitionerComments: this.props.activeTestDrivePractitionerComments
    };

    this.savePractitionerRatingToSession = this.savePractitionerRatingToSession.bind(this);
    this.saveAllClientInputToSession = this.saveAllClientInputToSession.bind(this);
    this.saveIssuesAndCommentsToSession = this.saveIssuesAndCommentsToSession.bind(this);

    this.onContinue = this.onContinue.bind(this);
  }

  //Get the current step from the URL
  getCurrentStep(){
    //e.g. URL of '/gather-info/contexts/intro' would have step of 'intro'
    //props.match: {"step":"intro"}
    const stepParam = this.props.match.params.step;
    if(stepParam){
      return(stepParam);
    }
    else{
      return(steps.CLIENT);
    }
  }

  //On Continue for a given step:
  // figure out the next step and go to it
  // and if we're totally done with this section, submit the data.
  onContinue() {
    let history = this.props.history;
    let nextStep = '';
    let nextRoute = '';
    let goToNextSection = false;
    const curURL = new URL(window.location.href);


    switch(this.getCurrentStep()){
      case steps.CLIENT:
        nextStep = steps.PRACTITIONER;
        break;
      case steps.PRACTITIONER:
        nextStep = steps.ISSUES;
        break;
      case steps.ISSUES:
        nextStep = steps.REVIEW;
        break;
      case steps.REVIEW:
        nextStep = '';
        goToNextSection = true;
        break;
      default:
        console.log("   default next step");
        nextStep = steps.CLIENT;
    }
    if (!goToNextSection) {
      nextRoute = BASE_URL + nextStep;
    } 
    else {
      // alert("Done with this section. Data saved are: " + JSON.stringify(this.state));
      nextRoute = NEXT_SECTION;
    }
    console.log("    pushing new route: " + nextRoute);
    history.push({
      pathname: nextRoute,
      search: curURL.search
    });
  }

  saveAllClientInputToSession(){
    let newActiveTestDrive = {
      ...this.state.activeTestDrive,
      activeTestDriveClientRating: this.state.activeTestDrive.activeTestDriveClientRating,
      activeTestDriveClientFeedback: this.state.activeTestDrive.activeTestDriveClientFeedback
    }
    this.props.updateSession('activeTestDrive', newActiveTestDrive );
  }
  savePractitionerRatingToSession(){
    let newActiveTestDrive = {
      ...this.state.activeTestDrive,
      activeTestDrivePractitionerRating: this.state.activeTestDrive.activeTestDrivePractitionerRating,
    }
    this.props.updateSession('activeTestDrive', newActiveTestDrive );
  }
  saveIssuesAndCommentsToSession(){
      let newActiveTestDrive = {
      ...this.state.activeTestDrive,
      activeTestDriveIssuesNoted: this.state.activeTestDrive.activeTestDriveIssuesNoted,
      activeTestDrivePractitionerComments: this.state.activeTestDrive.activeTestDrivePractitionerComments
    }
    this.props.updateSession('activeTestDrive', newActiveTestDrive );

  }

  //the keys are the names of the local state variables, defined above in the constructor
  updateLocalState(key) {
    return evt => {
      const target = evt.target; /* which input has been changed */
      let value = target.type === 'checkbox' ? target.checked: target.value;

      //handle 'issuesNoted' differently, since that holds an array rather than a single value
      if(key === 'activeTestDriveIssuesNoted'){
        const newItem=target.value;
        const newItemIndex = this.state.activeTestDrive.activeTestDriveIssuesNoted.indexOf(newItem);
        let issuesNoted = [...this.state.activeTestDrive.activeTestDriveIssuesNoted];
        //if an activity is checked: add it, if not already in list
        if((value===true) && (newItemIndex === -1)) {
          issuesNoted.push(newItem);
        }
        //activity unchecked: remove it, if already in the list
        else if ((value===false) && (newItemIndex !== -1)){
          issuesNoted.splice(newItemIndex, 1);
        }
        value = issuesNoted;
      }
      
      this.setState({
        activeTestDrive: {
          ...this.state.activeTestDrive,
          [key]: value
        }
      });

    }
  }

  //If new props come in after rendering, update the views in this tab.
  //(This occurs when you refresh a view and it pulls data from the database.)
  //a MANUAL TEST for this: refresh /test-drive/rate/review when logged in and showing some ratings data.
  //if this is working, you will see the same data re-appear upon refresh. if not, it will say 'None entered' for every field
  componentDidUpdate(prevProps, prevState){
    if (_.isEqual(this.props.activeTestDrive, prevProps.activeTestDrive) === false){
      console.log("--incoming activeTestDrive: " + this.props.activeTestDrive + " differ from prev activeTestDrive: " + prevProps.activeTestDrive);
      this.setState({'activeTestDrive': this.props.activeTestDrive});
    };
  }

  render() {
    console.log("rendering TestDriveRate, firstName: " + this.props.firstName);
    const firstName = this.props.firstName;
    const pronouns = this.props.pronouns;
    const isLowTechPath = this.props.isLowTechPath;
    const activeAccessMethodCategory = this.props.activeTestDrive.activeAccessMethodCategory;
    const curURL = new URL(window.location.href);
    const searchQuery = curURL.search;
    const dev = this.props.dev;

    return(
    <>
    <Switch>
      <Route path={BASE_URL+ steps.CLIENT}>
        <TestDriveRateClient
          key={steps.CLIENT}
          firstName={firstName}
          pronouns={pronouns}
          onContinue={this.onContinue}
          activeTestDriveClientRating={this.state.activeTestDrive.activeTestDriveClientRating}
          activeTestDriveClientFeedback={this.state.activeTestDrive.activeTestDriveClientFeedback}
          onChangeActiveTestDriveClientRating={this.updateLocalState("activeTestDriveClientRating")}
          onChangeActiveTestDriveClientFeedback={this.updateLocalState("activeTestDriveClientFeedback")}
          saveFormData={this.saveAllClientInputToSession}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL+ steps.PRACTITIONER}>
        <TestDriveRatePractitioner
          key={steps.PRACTITIONER}
          firstName={firstName}
          pronouns={pronouns}
          onContinue={this.onContinue}
          activeTestDrivePractitionerRating={this.state.activeTestDrive.activeTestDrivePractitionerRating}
          onChangeActiveTestDrivePractitionerRating={this.updateLocalState("activeTestDrivePractitionerRating")}
          saveFormData={this.savePractitionerRatingToSession}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL+ steps.ISSUES}>
        <TestDriveRateIssues
          key={steps.ISSUES}
          firstName={firstName}
          pronouns={pronouns}
          isLowTechPath={isLowTechPath}
          onContinue={this.onContinue}
          activeAccessMethodCategory={activeAccessMethodCategory}
          activeTestDriveIssuesNoted={this.state.activeTestDrive.activeTestDriveIssuesNoted}
          activeTestDrivePractitionerComments={this.state.activeTestDrive.activeTestDrivePractitionerComments}
          onChangeActiveTestDriveIssuesNoted={this.updateLocalState("activeTestDriveIssuesNoted")}
          onChangeActiveTestDrivePractitionerComments={this.updateLocalState("activeTestDrivePractitionerComments")}
          saveFormData={this.saveIssuesAndCommentsToSession}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL+ steps.REVIEW}>
        <TestDriveRateReview
          key={steps.REVIEW}
          firstName={firstName}
          pronouns={pronouns}
          activeTestDriveClientRating={this.state.activeTestDrive.activeTestDriveClientRating}
          activeTestDriveClientFeedback={this.state.activeTestDrive.activeTestDriveClientFeedback}
          activeTestDrivePractitionerRating={this.state.activeTestDrive.activeTestDrivePractitionerRating}
          activeTestDriveIssuesNoted={this.state.activeTestDrive.activeTestDriveIssuesNoted}
          activeTestDrivePractitionerComments={this.state.activeTestDrive.activeTestDrivePractitionerComments}
          onContinue={this.onContinue}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL}>
        <Redirect to={BASE_URL + steps.CLIENT + searchQuery} />
      </Route>
    </Switch>
    </>
    );
  }
}

TestDriveRate.propTypes = propTypes;
TestDriveRate.defaultProps = defaultProps;

// withRouter wrapper provides access to the match, location, and history props (used in onContinue)
export default withRouter(TestDriveRate);
